module.exports = __webpack_public_path__ + "img/download.da4f345b.svg";